import { types } from '../../actions/backendSnooze';

interface SnoozeState {
    snoozeFor: number | null;
}

export const initialState: SnoozeState = {
    snoozeFor: null
};

const applyCountdown = (timer: number) => timer - 1;

interface ReducerAction {
    type?: string;
    payload?: {
        snoozeFor?: number;
    };
}

export default function snoozeReducer(state: SnoozeState | undefined, action: ReducerAction = {}): SnoozeState {
    const currentState = state ?? initialState;
    const { type, payload = {} } = action;

    switch (type) {
        case types.SET_SNOOZE_TIMER_SUCCESS:
            return { ...currentState, snoozeFor: payload.snoozeFor ?? null };
        case types.SNOOZE_COUNTDOWN: {
            const { snoozeFor = 0 } = payload;
            return { ...currentState, snoozeFor: applyCountdown(snoozeFor) };
        }
        default:
            return currentState;
    }
}
